import React, { useState } from 'react';

import { type FooterLevelOneGroup } from '~/interfaces/HeaderFooterNavV2';

import FooterNavGroupTitle from './components/FooterNavGroupTitle';
import styles from './FooterNavGroup.module.css';

const Sublink = ({ link, name }: {link: string;name: string;}) => {
  return (
    <li className={styles.subLinkItem}>
			<a className={styles.subLink} href={link} title={name}>
				{name}
			</a>
		</li>);

};

export const FooterNavGroup = ({ name, subLinks }: FooterLevelOneGroup) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <li
      className={styles.footerNavGroupWrapper}
      data-testid="footer-level-one-group">

			<FooterNavGroupTitle isOpen={isOpen} title={name} toggle={toggle} />
			<ul
        className={`${styles.footerNavSubLinks} ${isOpen ? styles.open : ''}`}>

				{subLinks.map(({ link, name }) =>
        <Sublink key={name} link={link} name={name} />
        )}
			</ul>
		</li>);

};